module.exports = __webpack_public_path__ + "static/assets/bb0b18c664cbbb05be54c26055908e95.svg";